// extracted by mini-css-extract-plugin
module.exports = {"close":"dialogCloseButton_close__orUtd","closePosition":"dialogCloseButton_closePosition__ysQGy"};